<template>
  <el-row :gutter="20" class="main_block">

    <div class="mianContent" >
      <div class="tagView">
        <div class="title_aside"></div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>安全中心</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-row :gutter="20" type="flex" class="row-bg" justify="space-around">
        <el-col :span="15">
          <h2 class="writeOff">注销须知</h2>
          <p>请您在申请注销前务必仔细阅读、充分理解并同意以下条款内容。</p>
          <p>您理解并同意：</p>
          <p>注销账户会影响您继续正常使用我们的服务！您将不能登录该账号使用我们的全部产品和服务，包括壹签、版权服务、权利卫士、网页取证等。</p>
          <p>请您在申请注销前，
            务必提前保存好账户内的相关文件、证书、合同、证据等电子数据。注销账户后，
            您的个人数据我们将从系统中删除，包括但不限于：个人信息、上传的文件、交易记录、产生的证据文件、相关证书、套餐剩余次数等，被删除的数据无法恢复。</p>
          <p>账户一旦被注销将不可恢复！您将无法找回您账户中的及与账户相关的任何内容、信息或数据。您已经获得的各种优惠、赠送次数、参与的活动等均将视为您自行放弃，将全部清零且无法继续使用。</p>
          <p>  如您已仔细阅读上述全部条款，仍选择注销您的账户，可通过电子邮件的方式向我们的邮箱<span>“service@tsa.cn”</span>发送申请或拨打我们的客服电话<span>400-0186-091</span>联系客服申请操作。 </p>
        </el-col>
      </el-row>
    </div>

  </el-row>
</template>

<script>
export default {
  name: "logout",
  data() {
    return {}
  },
  created() {
  },
  components: {}
}
</script>

<style lang="less">
.other{
  flex: 1;
  width: 94.5%;
  background: #fff;
  margin-left: -20px;
}
.el-col{
  margin-top: 36px;
  p{

    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    line-height: 22px;
    margin-bottom: 20px;

    &:nth-child(1){
      margin-bottom: 40px;
    }
  }
  span{
    color: #3F7DF7;
  }
  .writeOff{
    margin-bottom: 20px;
    font-size: 16px;
    font-weight: 700;
  }
}

</style>